import {Injectable} from '@angular/core';
import {MedicalRecordVisitReasonModel} from '../../api/model/medicalRecordVisitReason.model';
import {MedicalRecordVisitReasonRepository} from './ngrx/medicalRecordVisitReason.repository';
import {MedicalRecordVisitReasonDataServiceAdapter} from './ngrx/medicalRecordVisitReasonDataService.adapter';
import {AbstractFindOneByIdService} from '../../../../../core/service/v2/service/findone/abstractFindOneById.service';

@Injectable()
export class MedicalRecordVisitReasonFindOneService
    extends AbstractFindOneByIdService<MedicalRecordVisitReasonModel, MedicalRecordVisitReasonModel> {

    constructor(public repository: MedicalRecordVisitReasonRepository,
                public dataServiceAdapter: MedicalRecordVisitReasonDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

}
